import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { UpdateMachinePayload } from "@src/types/gateways-with-machines";
import { Machine } from "./get-machine-by-id";

export const putUpdateMachine = async (
  namespace: string,
  machineId: string,
  payload: UpdateMachinePayload,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    return await axios.put<Machine>(
      `${url}/api/v4/ns/${namespace}/machines/${encodeURIComponent(machineId)}`,
      payload,
      { headers },
    );
  } catch (error) {
    if (isAxiosError(error)) {
      console.error("Axios error:", error);
      throw error;
    }

    throw new Error("An unexpected error occurred while updating machine.");
  }
};
